<template>
  <div class="p-2">
    <h1 class="lead text-center">{{ getTitle }}</h1>
    <table class="table">
      <tr>
        <th>{{ $t("grid.slots.interphone.type") }}</th>
        <td>{{ getType }}</td>
      </tr>
      <tr>
        <th>Ivr</th>
        <td>{{ data.data.ivr ? data.data.ivr : "-" }}</td>
      </tr>
      <tr>
        <th>{{ $t("grid.slots.interphone.created") }}</th>
        <td>{{ formatDateAssigned(data.data.created_at) }}</td>
      </tr>
      <tr>
        <th>{{ $t("grid.slots.interphone.updated") }}</th>
        <td>{{ formatDateAssigned(data.data.updated_at) }}</td>
      </tr>
      <tr v-if="data.data.user">
        <th>{{ $t("grid.slots.interphone.user") }}</th>
        <td>{{ data.data.user }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { computed } from "@vue/composition-api";

export default {
  props: {
    data: Object,
  },
  setup(props) {
    const formatDateAssigned = (value) => {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    };

    const getTitle = computed(() => {
      return props.data.data.camera_type === "pbxdevice"
        ? props.data.data.name
        : props.data.data.device_id;
    });

    const getType = computed(() => {
      return props.data.data.camera_type === "pbxdevice"
        ? props.data.data.camera_type
        : (props.data.data.type_device_interphone &&
            props.data.data.type_device_interphone.type) ||
            "-";
    });

    return {
      formatDateAssigned,
      getTitle,
      getType,
    };
  },
};
</script>

<style></style>

